// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fhtI","footer":"styles_footer__2XbI6","passCodeTooltip":"styles_passCodeTooltip__2DX4t"};